import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth/auth.guard';
import { AuthModule } from './auth/auth.module';
import { AuthComponent } from './auth/auth.component';
import { LoginComponent } from './auth/login/login.component';
import { ForogtPasswordComponent } from './auth/forogt-password/forogt-password.component';
import { ResetPasswordComponent } from './auth/reset-password/reset-password.component';
import { ResetEmailComponent } from './auth/reset-email/reset-email.component';

const routes: Routes = [
  {
    path: 'login',
    component: AuthComponent,
    children: [{ path: '', component: LoginComponent }],
  },
  {
    path: 'forgot-password',
    component: AuthComponent,
    children: [{ path: '', component: ForogtPasswordComponent }],
  },
  {
    path: 'reset-password/:uid/:token',
    component: AuthComponent,
    children: [{ path: '', component: ResetPasswordComponent }],
  },
  {
    path: 'verify-email/:uid/:data/:token',
    component: ResetEmailComponent,
  },
  {
    canActivate: [AuthGuard],
    path: '',
    loadChildren: () => import('./layout/layout.module').then((m) => m.LayoutModule),
  },
];

@NgModule({
  imports: [AuthModule, RouterModule.forRoot(routes)],
  exports: [RouterModule],
  declarations: [ResetEmailComponent],
})
export class AppRoutingModule {}
